export default __webpack_public_path__ + "static/media/new_kingdom_4_3x.7a226832.webp";